/**
 * Product Single
 * 
 * @module product-single
 * @version 1.0.0
 * @extends HTMLElement
*/

customElements.component = 'product-single';

if (!customElements.get(customElements.component)) {
    class componentProductSingle extends HTMLElement {

        /**
         * Accordion web component.
         * 
         * @constructor
         */
        constructor() {

            super();
            
            this.initEvents();
        }

        /**
         * Init component events.
         * 
         * @returns {undefined}
         */
        initEvents() {

            // This function will add the variant parameter into URL page
            //this.initVariantSelect();
        }
        
        /**
         * Init form variant select to handle the varaint id on add to cart
         * 
         * @return {undefined}
         */
        initVariantSelect() {

            // On variant change
            window.addEventListener('variant-change', event => {
                if(event.detail.product.id == this.dataset.productSingleId) {

                    let productHandle = event.detail.product.handle;
                    let varianSelector = this.querySelector('variant-selector[data-handle="'+ productHandle +'"]');

                    if(!varianSelector) return false;

                    let productFirstVariant = varianSelector.dataset.productFirstVariant;
                    let params = new URLSearchParams(document.location.search);

                    //page-loaded
                    if(event.detail.eventType == "page-loaded") {

                        if(params.get("variant")) {
                            params.delete("variant");
                            params.append('variant', productFirstVariant);
                            window.history.replaceState({path: "?variant="+ productFirstVariant}, '', "?" + params.toString());
                        }
                        else {
                            params.delete("variant");
                            params.append('variant', event.detail.variantId);
                            window.history.replaceState({path: "?variant="+ event.detail.variantId}, '', "?" + params.toString());
                        }
                    }
                    else { //variant-clicked
                        if(params.get("variant")) {
                            params.delete("variant");
                            params.append('variant', event.detail.variantId);
                            window.history.replaceState({path: "?variant="+ event.detail.variantId}, '', "?" + params.toString());
                        }
                    }
                }
            });
        }
    }

    customElements.define(customElements.component, componentProductSingle);
}